// extracted by mini-css-extract-plugin
module.exports = {"McsTitleBase":"McsTitleSecondary_McsTitleBase__2nAUo","McsTitleTitle":"McsTitleSecondary_McsTitleTitle__EZnNa"};